module.exports = __webpack_public_path__ + "img/icon-sti-sti-dest-rts-overdue.dc1e613d.svg";